import dayjs from 'dayjs';

export default class Player {

	public static readonly UNKNOWN: string = 'unbekannt';

	public readonly currentTeamId: any;
	public readonly position: boolean;
	public readonly nationalityId1: any;
	public readonly nationalityId2: any;

	constructor(private data: any) {
		this.currentTeamId = data.currentTeamId;
		this.position = data.position;
		this.nationalityId1 = data.nationalityId_1;
		this.nationalityId2 = data.nationalityId_2;
	}

	name(): string {
		return `${this.data.firstName} ${this.data.lastName}`;
	}

	birthday(): string {
		return dayjs(this.data.birthday).format('D. MMMM YYYY');
	}

	age(): number | undefined {
		if (!this.data.birthday) {
			return undefined;
		}
		return dayjs().diff(dayjs(this.data.birthday), 'year', false);
	}

	height(): string {
		return this.data.height ? `${this.data.height} cm` : '-';
	}

	weight(): string {
		return this.data.weight ? `${this.data.weight} kg` : '-';
	}

	isGoalie(): boolean {
		return this.data.position === 'G';
	}

}
